module.exports = __webpack_public_path__ + "static/media/10.7f02edea.png";